import WalkthroughNav from '../../components/WalkthroughNav';

export default [WalkthroughNav];
